import Api from '@/api/index';

const Bill = {
  namespaced: true,
  state: {
    allBills: [],
    statusByTitle: {},
    pagination: {
      current_page: 1,
      per_page: 10,
      total_count: 0,
      total_pages: 1,
      total_value: 0
    }
  },
  getters: {
    
  },

  mutations: {
    setAllBills(state, bills) {
      state.allBills = [...bills]
    },
    setPagination(state, pagination) {
      state.pagination = { ...pagination }
    },
    updateBill(state, bill) {
      let idx = state.allBills.findIndex(b => parseInt(b.id) == parseInt(bill.data.id))
      state.allBills.splice(idx, 1)
    }

    // this.status_missed_id = state.allBills.find(s=>s.title == 'Missed').id
    // this.status_bacon_id = state.allBills.find(s=>s.title == 'Bacon').id
  },

  actions: {
    index(context, filters) {
      return Api.Bill.index(filters).then(r => r.data).then(r => {
        context.commit('setAllBills', r.data)
        // Atualizar paginação se existir nos metadados
        if (r.meta && r.meta.pagination) {
          context.commit('setPagination', r.meta.pagination)
        }
        return true
      }).catch(err => {
        console.log(err)
        throw Error(err)
      })
    },
    update(context, bill) {
      let notification = {};
      Api.Bill.update(bill).then(r => r.data).then(r => {
        notification.type = 'success';
        notification.msg = 'Feito com sucesso';
        context.commit('updateBill', r);
      }).catch(error => {
        notification.type = 'error';
        notification.msg = `Erro: ${error}`
      })
    }

  }

};

export default Bill;
